import { Component, inject } from '@angular/core';

import { ToastService } from './toast.service';

const TYPE_STYLES: Record<string, string> = {
  success: 'border-l-4 border-l-es-success bg-green-500/10',
  error: 'border-l-4 border-l-es-error bg-red-500/10',
  warning: 'border-l-4 border-l-es-warning bg-star-orange/10',
  info: 'border-l-4 border-l-es-info bg-echo-blue/10',
};

/**
 * Fixed overlay that renders active toast notifications from ToastService and allows dismissal.
 */
@Component({
  selector: 'es-toast-container',
  template: `
    <div class="fixed top-4 right-4 z-[2000] flex flex-col gap-2 min-w-[300px]">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="px-4 py-3 rounded-lg bg-[var(--bg-card)] border border-[var(--border)] shadow-lg animate-slide-down flex items-center justify-between gap-3"
          [class]="TYPE_STYLES[toast.type]"
        >
          <span class="text-sm text-[var(--text)]">{{ toast.message }}</span>
          <button
            class="text-[var(--text-secondary)] hover:text-[var(--text)] cursor-pointer text-xs"
            (click)="toastService.dismiss(toast.id)"
          >✕</button>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  toastService = inject(ToastService);
  TYPE_STYLES = TYPE_STYLES;
}
